/* eslint-disable no-undef */
import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getMedicineStockReport = async (token) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/pharmacy/medicines/stock_report`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "Something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "Something went wrong");
  }
};
